import Vue from 'vue'
import api from '@/services/Api';
import router from '../../router'

import {
    USER_REQUEST,
    USER_SUPERIOR_REQUEST,
    USER_SUPERIOR_SUCCESS,
    USER_ERROR,
    USER_SUCCESS,
    USER_SET_PASSWORD,
    USER_DISMISS_NOTIFICATION,
    USER_SET_BADGE_NOTIFICATIONS,
    USER_SET_PLACE,
    USER_SET_YEAR,
    USER_SET_KNOWLEDGE_ZONE_CATEGORY
} from '../actions/user'

import {AUTH_LOGOUT} from '../actions/auth'

import {getField, updateField} from 'vuex-map-fields';

// ----------------------------- o

const state = {
    status: '',
    extras: {
        isPasswordChange: null,
        lastLogin: '',
    },
    profile: {
        firstname: '',
        lastname: '',
        email: '',
        iban: '',
        place: '',
        zipCode: '',
        city: '',
        entrepreneur: '',
        birthday: '',
        pesel: '',
        taxOfficeName: '',
        taxOfficeAddress: ''
    },
    role: null,
    notifications: [],
    showBadgeNotifications: false,
    places: [],
    currentPlace: null,
    currentYear: new Date().getFullYear(), // default year
    currentKnowledgeZoneCategory: null,
    superior: null
};

// ----------------------------- o

const getters = {
    authStatus: state => state.status,
    authError: state => state.error,
    getProfile: state => state.profile,
    getRole: state => state.role,
    getPlaces: state => state.places,
    isProfileLoaded: state => !!state.profile.firstname,
    hasChangedPassword: state => state.extras.isPasswordChange,
    showSlider: state => state.extras.showSlider,
    getNotifications: state => state.notifications,
    getField, // mapFields
    showBadgeNotifications: state => state.showBadgeNotifications,
};

// ----------------------------- o

const actions = {
    //
    [USER_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(USER_REQUEST);
            // get user
            api.get('/api/v1/user/get').then(resp => {
                //
                commit(USER_SUCCESS, resp.data.message)
                //
                dispatch(USER_SUPERIOR_REQUEST)
                //
                if (resp.data.message.forceLogOut === true) {
                    console.log("%c user has been forced to logout!", 'background: #ff0000; color: #fff');
                    commit(USER_ERROR, resp.data.message);
                    dispatch(AUTH_LOGOUT);
                    router.push({name: 'Error401'})
                }
                resolve(resp)
            })
            .catch(err => {
                commit(USER_ERROR, 'error');
                if (err.response.status === 401) {
                    console.log("%c token has expired!", 'background: #ff0000; color: #fff');
                    dispatch(AUTH_LOGOUT);
                    router.push({name: 'Login'})
                }
                reject(err)
            })
        })
    },
    //
    [USER_SUPERIOR_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            // get user's superior
            api.get('/api/v1/user/superior').then(resp => {
                commit(USER_SUPERIOR_SUCCESS, resp.data.data);
                resolve(resp)
            })
            .catch(err => {
                commit(USER_ERROR, 'error');
                reject(err)
            })
        })
    },
};

// ----------------------------- o

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [USER_SUCCESS]: (state, resp) => {
        state.status = 'success';
        state.profile = resp.profile;
        state.places = resp.profile.userDetails || [];
        state.role = resp.role || '';
        state.extras = {
            ...resp.extras,
        };
        state.showBadgeNotifications = resp.showBadgeNotifications
        state.notifications = resp.notifications || [];
    },
    [USER_SUPERIOR_SUCCESS]: (state, resp) => {
        state.superior = resp
    },
    [USER_SET_PASSWORD]: (state, value) => {
        Vue.set(state.extras, 'isPasswordChange', value)
    },
    [USER_DISMISS_NOTIFICATION]: (state, value) => {
        state.notifications[value.index].isRead = value.bool
    },
    [USER_SET_BADGE_NOTIFICATIONS]: (state, value) => {
        state.showBadgeNotifications = value
    },
    [USER_SET_PLACE]: (state, value) => {
        state.currentPlace = value
    },
    [USER_SET_YEAR]: (state, value) => {
        state.currentYear = value
    },
    [USER_SET_KNOWLEDGE_ZONE_CATEGORY]: (state, value) => {
        state.currentKnowledgeZoneCategory = value
    },
    [USER_ERROR]: (state, resp) => {
        state.error = resp
    },
    [AUTH_LOGOUT]: (state) => {
        state.status = 'logout';
        state.profile = {};
        state.extras = {};
    },
    updateField,
};

// ----------------------------- o

export default {
    state,
    getters,
    actions,
    mutations,
}
